// extracted by mini-css-extract-plugin
module.exports = {"button":"Favorite_button_18GLX","checkmark-thin":"Favorite_checkmark-thin_3ZkcX","optional":"Favorite_optional_EwR4x","favoriteIcon":"Favorite_favoriteIcon_1QhH-"};